import React, { useCallback } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import styles from './Modal.css';
import Button from '../../atoms/Button/Button';

const Modal = ({ open, title, onClose, children }) => {
  const handleScrimClick = useCallback(
    (event) => {
      event.stopPropagation();
      onClose();
    },
    [onClose],
  );

  if (!open) {
    return null;
  }

  return createPortal(
    <div className={styles.Modal__scrim} onClick={handleScrimClick}>
      <div className={styles.Modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.Modal__header}>
          <div className={styles.Modal__title}>{title}</div>
          <Button
            className={styles.Modal__close}
            icon="close"
            rounded
            onClick={onClose}
          ></Button>
        </div>
        <div className={styles.Modal__content}>{children}</div>
      </div>
    </div>,
    document.body,
  );
};

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default Modal;
